module.exports = __webpack_public_path__ + "media/assets/icons/ic-checkbox-empty-208b2084570858ca00a60151df2a2a09.svg";